import React from 'react';
import Header from '../../components/ui/Header';
import BreadcrumbTrail from '../../components/ui/BreadcrumbTrail';
import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

export default function DistrictInfo() {
  const genderData = [
    { name: 'ชาย', value: 40340 },
    { name: 'หญิง', value: 41938 },
  ];
  const COLORS = ['#3b82f6', '#f472b6'];

  const householdData = [
    { name: 'ครัวเรือน', value: 34941 },
  ];

  const subdistricts = [
    { name: 'เวียง', villages: 25 },
    { name: 'สันทรายงาม', villages: 7 },
    { name: 'ตับเต่า', villages: 25 },
    { name: 'หงาว', villages: 20 },
    { name: 'งิ้ว', villages: 25 },
    { name: 'ปล้อง', villages: 12 },
    { name: 'ศรีดอนไชย', villages: 10 },
    { name: 'หนองแรด', villages: 7 },
    { name: 'แม่ลอย', villages: 13 },
    { name: 'เชียงเคี่ยน', villages: 12 },
  ];

  const agencies = [
    'ที่ทำการปกครองอำเภอเทิง',
    'ศาลจังหวัดเทิง',
    'สำนักงานอัยการจังหวัดเทิง',
    'สพป.เชียงราย เขต 4',
    'กศน.อำเภอเทิง',
    'สำนักงานปศุสัตว์อำเภอเทิง',
    'สำนักงานประมงอำเภอเทิง',
    'ศูนย์ส่งเสริมเทคโนโลยีการเกษตรที่สูงดอยผาหม่น',
    'สำนักงานที่ดินจังหวัดเชียงราย สาขาเทิง',
    'สำนักงานพัฒนาชุมชนอำเภอเทิง',
    'สำนักงานสัสดีอำเภอเทิง',
    'สำนักงานเกษตรอำเภอเทิง',
    'สำนักงานสาธารณสุขอำเภอเทิง',
    'สำนักงาน ท้องถิ่นอำเภอเทิง',
    'โรงพยาบาลเทิง',
    'สถานีตำรวจภูธรเทิง',
    'สำนักงานบังคับคดีจังหวัดเชียงราย (ส่วนย่อยเทิง)',
    'สำนักงานสรรพากรพื้นที่ สาขาเทิง',
    'เรือนจำอำเภอเทิง',
    'วนอุทยานภูชี้ฟ้า',
    'หน่วยป้องกันและรักษาป่าเชียงราย ที่ 4 (เชียงเคี่ยน)',
    'หน่วยป้องกันและรักษาป่าเชียงราย ที่ 12 (แม่อิงฝั่งขวา)',
    'สำนักงานขนส่งจังหวัดเชียงราย สาขาเทิง',
    'สำนักงานคุมประพฤติจังหวัดเชียงราย สาขาเทิง',
    'การไฟฟ้าส่วนภูมิภาค อ.เทิง',
    'การประปาส่วนภูมิภาค สาขาเทิง',
    'ที่ทำการไปรษณีย์เทิง',
  ];

  const banks = [
    'ธ.ก.ส. สาขาเทิง',
    'ธ.ก.ส. สาขาปล้อง',
    'ธนาคารออมสิน สาขาเทิง',
    'ธนาคารกสิกรไทย สาขาเทิง',
    'ธนาคารกรุงไทย สาขาเทิง',
  ];

  // ใช้ภาพเก่าที่อัปโหลดไว้ใน public/assets/images ชื่อไฟล์รูปแบบ "ภาพที่ว่าการอำเภอเทิงในอดิต (n).jpg"
  const gallery = [1,2,3,4,5,6,7,8,9].map((n) => ({
    src: `/assets/images/ภาพที่ว่าการอำเภอเทิงในอดิต (${n}).jpg`,
    caption: `ที่ว่าการอำเภอเทิง (${n === 7 ? 'ปัจจุบัน' : 'ภาพในอดีต'})`,
    source: 'คลังภาพอำเภอเทิง',
    href: '#',
  }));

  const references = [
    { title: 'พระราชบัญญัติปกครองท้องที่ ร.ศ. 116', href: '#'},
    { title: 'ประวัติเมืองภูกามยาวและหัวเมืองฝ่ายเหนือ', href: '#'},
    { title: 'ข้อมูลสถิติพื้นฐานอำเภอเทิง (ประชากร/พื้นที่)', href: '#'},
  ];

  return (
    <div className="min-h-screen bg-background font-sans text-foreground">
      <Header />
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <BreadcrumbTrail />
      </div>

      {/* HERO SECTION */}
      <section
        className="relative h-[50vh] md:h-[60vh] bg-cover bg-center flex items-center justify-center"
        // ใช้ภาพอดีตภาพแรกเป็นพื้นหลัง ถ้าไม่มีให้ fallback เป็นภาพเดิม
        style={{ backgroundImage: "url('/assets/images/ภาพที่ว่าการอำเภอเทิงในอดิต (1).jpg'), url('/assets/images/Gemini_Generated_Image_i40v6ai40v6ai40v.png')" }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative z-10 text-center text-white">
          <h1 className="text-3xl md:text-5xl font-bold mb-3">ประวัติความเป็นมา อำเภอเทิง</h1>
          <p className="text-base md:text-xl">
            พระธาตุจอมจ้อคู่บ้าน · น้ำลาว หงาว อิงคู่เมือง · ภูชี้ฟ้าลือเลื่อง · งามประเทืองดอกเสี้ยวบาน
          </p>
        </div>
      </section>

      {/* TIMELINE SECTION */}
      <section className="max-w-5xl mx-auto py-12 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">ประวัติศาสตร์สำคัญ</h2>
        <div className="space-y-6 border-l-4 border-primary pl-6">
          <div>
            <h3 className="font-semibold text-xl">พ.ศ. 1663</h3>
            <p className="text-muted-foreground">สมัยขุนเจื๋อง เมืองภูกามยาว เริ่มมีการกล่าวถึงเมืองเทิง</p>
          </div>
          <div>
            <h3 className="font-semibold text-xl">ร.ศ. 116 (พ.ศ. 2483)</h3>
            <p className="text-muted-foreground">ตั้งเป็น “กิ่งแขวงเมืองเทิง” ขึ้นกับบริเวณนครน่าน</p>
          </div>
          <div>
            <h3 className="font-semibold text-xl">พ.ศ. 2457</h3>
            <p className="text-muted-foreground">ยกฐานะเป็น “อำเภอเทิง” ขึ้นต่อจังหวัดเชียงราย</p>
          </div>
        </div>
      </section>

      {/* HISTORY NARRATIVE (DETAILED) */}
      <section className="max-w-6xl mx-auto pb-6 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">ประวัติความเป็นมา (โดยสังเขป)</h2>
        <div className="space-y-4 text-muted-foreground leading-7">
          <p>
            อำเภอเทิงมีพัฒนาการทางการปกครองสืบเนื่องยาวนาน เริ่มจากการเป็นหัวเมืองขึ้นของเมืองภูกามยาวในสมัยขุนเจื๋อง
            ต่อมามีการขยายตัวของชุมชนและการตั้งถิ่นฐาน กระทั่งถูกจัดเข้าในโครงสร้าง “บริเวณนครน่าน”
            ตามกฎหมายการปกครองท้องที่ ร.ศ. 116 (พ.ศ. 2483) ในฐานะ “กิ่งแขวงเมืองเทิง”.
          </p>
          <p>
            ในช่วงเวลาดังกล่าว ได้แบ่งเขตชุมชนออกเป็น 14 แคว้น ประกอบด้วย เวียงเทิง บ้านหงาว ตับเต่า บ้านแพร่ บ้านเอียน บ้านงิ้ว
            บ้านแม่ต้า บ้านเกี๋ยง แม่ต๊าก บ้านปล้อง บ้านเชียงเคี่ยน บ้านป่าตาล บ้านสัก และบ้านดอนไชย ซึ่งแต่ละแคว้นเป็นศูนย์รวมของชุมชนรอบ ๆ
            และเป็นฐานรากสำคัญของเครือข่ายหมู่บ้านในพื้นที่เทิงปัจจุบัน.
          </p>
          <p>
            พ.ศ. 2447 ทางราชการได้โอนเมืองเทิงและเชียงของจากบริเวณน่านเหนือมาขึ้นกับเมืองเชียงราย ก่อนจะมีการยกฐานะ
            “กิ่งแขวงเวียงเทิง” เป็น “อำเภอเทิง” เมื่อ พ.ศ. 2457 โดยมีขุนวัฒนานุการ (ร.อ.ท.โป๊ะ วัฒนะสมบัติ) เป็นนายอำเภอคนแรก
            นับแต่นั้น อำเภอเทิงได้พัฒนาเป็นศูนย์กลางบริการภาครัฐและเศรษฐกิจของชุมชนโดยรอบ เชื่อมโยงพื้นที่ชายแดนและแหล่งท่องเที่ยวภูชี้ฟ้า
            จนเป็นหนึ่งในอำเภอสำคัญของจังหวัดเชียงรายในปัจจุบัน.
          </p>
        </div>

        {/* Gallery */}
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {gallery.map((g, idx) => (
            <figure key={idx} className="bg-card rounded-xl shadow-government overflow-hidden border border-border">
              <img
                src={g.src}
                alt={g.caption}
                className="w-full aspect-[16/9] object-cover"
                loading="lazy"
                onError={(e) => { e.currentTarget.src = '/assets/images/Gemini_Generated_Image_i40v6ai40v6ai40v.png'; }}
              />
              <figcaption className="p-3 text-sm text-muted-foreground flex items-center justify-between">
                <div>
                  <div className="text-foreground font-medium">{g.caption}</div>
                  <div className="text-xs">ที่มา: {g.source}</div>
                </div>
                {g.href ? (
                  <a href={g.href} target="_blank" rel="noreferrer" className="text-primary hover:underline text-xs">ดูแหล่งอ้างอิง</a>
                ) : null}
              </figcaption>
            </figure>
          ))}
        </div>

        {/* References */}
        <div className="mt-6 bg-card rounded-xl shadow-government p-4">
          <h3 className="font-semibold mb-2">แหล่งอ้างอิง</h3>
          <ul className="list-disc pl-5 text-sm text-muted-foreground space-y-1">
            {references.map((r) => (
              <li key={r.title}><a href={r.href} target="_blank" rel="noreferrer" className="hover:underline">{r.title}</a></li>
            ))}
          </ul>
        </div>
      </section>

      {/* DISTRICT MAP SECTION */}
      <section className="bg-muted/30 py-12 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">แผนที่อำเภอเทิง</h2>
        <div className="max-w-5xl mx-auto">
          <figure className="bg-card rounded-2xl shadow-government overflow-hidden border border-border">
            <div className="w-full bg-black/5 flex items-center justify-center">
              <img
                src="/assets/images/แผนที่อำเภอเทิง.gif"
                alt="แผนที่อำเภอเทิง"
                className="w-full h-auto object-contain md:aspect-[16/9]"
                loading="lazy"
              />
            </div>
            <figcaption className="p-3 text-sm text-muted-foreground flex items-center justify-between">
              <div>
                <div className="text-foreground font-medium">แผนที่ที่ตั้งและอาณาเขต อำเภอเทิง</div>
                <div className="text-xs">ที่มา: คลังภาพอำเภอเทิง</div>
              </div>
              <a href="/assets/images/แผนที่อำเภอเทิง.gif" target="_blank" rel="noreferrer" className="text-primary hover:underline text-xs">เปิดภาพขนาดเต็ม</a>
            </figcaption>
          </figure>
        </div>
      </section>

      {/* MOTTO SECTION */}
      <section className="bg-muted/30 py-12 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">คำขวัญอำเภอ</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {['พระธาตุจอมจ้อคู่บ้าน','น้ำลาว หงาว อิงคู่เมือง','ภูชี้ฟ้าลือเลื่อง','งามประเทืองดอกเสี้ยวบาน'].map((motto, i) => (
            <div key={i} className="bg-card rounded-2xl shadow-government p-6 text-center">
              <p className="text-lg font-semibold">{motto}</p>
            </div>
          ))}
        </div>
      </section>

      {/* GENERAL INFO SECTION */}
      <section className="max-w-6xl mx-auto py-12 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">ข้อมูลทั่วไป</h2>
        <div className="grid md:grid-cols-2 gap-8 items-start">
          <div>
            <h3 className="font-semibold mb-2">ที่ตั้ง</h3>
            <p className="text-muted-foreground leading-7">
              ๑) ที่ตั้ง อำเภอเทิง จังหวัดเชียงราย อยู่ทางทิศตะวันออกของจังหวัดเชียงราย ระยะทางห่างจากตัวจังหวัดประมาณ ๖๕ กิโลเมตร ระยะทางห่างจากกรุงเทพ ๘๙๑ กิโลเมตร ลักษณะพื้นที่โดยประมาณ ๗๙๕ ตารางกิโลเมตร  ลักษณะภูมิประเทศส่วนใหญ่เป็นที่ราบลุ่มและที่ราบเชิงเขาสลับกับพื้นที่ภูเขา แยกเป็นที่ราบ ๔๕๖ ตารางกิโลเมตร พื้นที่ภูเขา ๓๑๕ ตารางกิโลเมตร ลักษณะภูมิอากาศมี ๓ ฤดู คือ ฤดูฝน ฤดูหนาว และฤดูร้อน อุณหภูมิเฉลี่ยสูงสุด  ๓๐.๗๐ ในเดือนเมษายน ต่ำสุด ๑๘.๖๐ ในเดือนธันวาคมและมกราคม พื้นที่มีความเหมาะสมในการปลูกข้าว พืชสวน และพืชไร่ โดยมีอาณาเขตติดต่อทั้ง ๔ ทิศดังนี้
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-muted-foreground">
              <li>
                <span className="font-medium text-foreground">ทิศเหนือ</span> ติดต่อกับ อำเภอพญาเม็งราย อำเภอขุนตาล อำเภอเวียงแก่น อำเภอเวียงชัย จังหวัดเชียงราย และสาธารณรัฐประชาธิปไตยประชาชนลาว
              </li>
              <li>
                <span className="font-medium text-foreground">ทิศใต้</span> ติดต่อกับ อำเภอภูซาง อำเภอจุน อำเภอเชียงคำ จังหวัดพะเยา และอำเภอป่าแดด จังหวัดเชียงราย
              </li>
              <li>
                <span className="font-medium text-foreground">ทิศตะวันออก</span> ติดต่อกับ อำเภอภูซาง อำเภอเชียงคำ จังหวัดพะเยา และสาธารณรัฐประชาธิปไตยประชาชนลาว
              </li>
              <li>
                <span className="font-medium text-foreground">ทิศตะวันตก</span> ติดต่อกับ อำเภอเมืองเชียงราย อำเภอป่าแดด อำเภอเวียงชัย อำเภอพญาเม็งราย จังหวัดเชียงราย
              </li>
            </ul>
            <p className="text-muted-foreground mt-3">
              ทั้งนี้ มีแนวเขตติดกับสาธารณรัฐประชาธิปไตยประชาชนลาวประมาณ ๑๖ กิโลเมตร
            </p>
          </div>
          <div className="rounded-xl overflow-hidden shadow-government border border-border">
            <iframe
              title="Thoeng District Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3638.835690841201!2d100.0785!3d19.6272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30d78c0a7f27b0d9%3A0x1049d7c0f2c043!2z4Liq4LiW4Liy4Lij4Lih4Lir4LmJ4Liy4Lij4Liw4LmA4Lie4Lij4Li14Lii!5e0!3m2!1sth!2sth!4v1693470472000!5m2!1sth!2sth"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>

      {/* GOVERNANCE SECTION */}
      <section className="bg-muted/30 py-12 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">การปกครอง</h2>
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-6">
            <div className="bg-card rounded-xl shadow-government p-5">
              <h3 className="font-semibold mb-3">ตำบลและจำนวนหมู่บ้าน (รวม 10 ตำบล / 156 หมู่บ้าน)</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-muted-foreground">
                {subdistricts.map((s) => (
                  <div key={s.name} className="flex items-center justify-between bg-muted/40 rounded-md px-3 py-2">
                    <span>{s.name}</span>
                    <span className="text-foreground font-medium">{s.villages} หมู่บ้าน</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-card rounded-xl shadow-government p-5">
              <h3 className="font-semibold mb-3">องค์กรปกครองส่วนท้องถิ่น (12 แห่ง)</h3>
              <p className="text-sm text-muted-foreground">เทศบาลตำบล 6 แห่ง และองค์การบริหารส่วนตำบล 6 แห่ง</p>
              <ul className="mt-3 list-disc pl-5 text-sm text-muted-foreground space-y-1">
                <li>เทศบาลตำบล: เชียงเคี่ยน, บ้านปล้อง, งิ้ว, สันทรายงาม, เวียงเทิง, หงาว</li>
                <li>องค์การบริหารส่วนตำบล: แม่ลอย, ปล้อง, หนองแรด, เวียง, ศรีดอนไชย, ตับเต่า</li>
              </ul>
            </div>
          </div>

          <div className="mt-6 bg-card rounded-xl shadow-government p-5">
            <h3 className="font-semibold mb-3">หน่วยงานราชการและรัฐวิสาหกิจในพื้นที่</h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 text-sm">
              {agencies.map((a) => (
                <div key={a} className="bg-muted/40 rounded-md px-3 py-2 text-muted-foreground">{a}</div>
              ))}
            </div>
          </div>

          <div className="mt-6 bg-card rounded-xl shadow-government p-5">
            <h3 className="font-semibold mb-3">สถาบันการเงิน</h3>
            <ul className="list-disc pl-5 text-sm text-muted-foreground space-y-1">
              {banks.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* POPULATION SECTION */}
      <section className="max-w-6xl mx-auto py-12 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">ประชากร</h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-card shadow-government rounded-xl p-4 flex flex-col items-center">
            <h3 className="font-semibold mb-4">เพศชาย / หญิง</h3>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie data={genderData} cx="50%" cy="50%" labelLine={false} outerRadius={80} dataKey="value">
                  {genderData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="bg-card shadow-government rounded-xl p-4 flex flex-col items-center">
            <h3 className="font-semibold mb-4">จำนวนครัวเรือน</h3>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={householdData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#10b981" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </section>

      <footer className="bg-primary text-primary-foreground py-8 px-6 text-center">
        <p className="mb-2">ที่ว่าการอำเภอเทิง จังหวัดเชียงราย</p>
        <p className="text-sm">โทร: 053-795-345 | Email: districtthoeng@gmail.com</p>
        <p className="mt-4 text-xs opacity-80">© 2025 อำเภอเทิง จังหวัดเชียงราย</p>
      </footer>
    </div>
  );
}


